export default __webpack_public_path__ + "static/media/2.33c71882.png";